import { Dispatch, SetStateAction, useState } from "react";
import styles from "../../../../components/FreeGift/FreeGift.module.css";
import { Button, Icon, TextField, Thumbnail } from "@shopify/polaris";
import { CollectionIcon, SearchIcon } from "@shopify/polaris-icons";
import { ProductObj, VariantsObj } from "../../../Bundles/Types";
import CloseIcon from "../../CartIcons/CloseIcon";

type FreeGiftProps = {
    handleInputChange: (index: any, updates: any) => void;
    free_gifts: any;
    selectedTab: any;
    offerError: string;
    setHasInteractedProduct: Dispatch<SetStateAction<boolean>>;
};

const FreeGiftReward = ({
    handleInputChange,
    free_gifts,
    selectedTab,
    offerError,
    setHasInteractedProduct,
}: FreeGiftProps) => {
    const [productSearchQuery, setProductSearchQuery] = useState("");

    const handleProductSearch = async () => {
        const preSelected = free_gifts?.map((product: ProductObj) => ({
            id: product?.id,
            variants: product?.variants.map((variant: VariantsObj) => ({
                id: variant?.id,
            })),
        }));

        const selected = await shopify.resourcePicker({
            type: "product",
            multiple: true,
            query: productSearchQuery,
            action: "select",
            selectionIds: preSelected,
            filter: {
                query: "status:active AND published_status:published",
                variants: true,
            },
        });
        if (selected) {
            const productsArr: ProductObj[] = [];
            selected?.map((p: any) => {
                productsArr.push({
                    id: p?.id,
                    images: p?.images,
                    title: p?.title,
                    handle: p?.handle,
                    quantity: 1,
                    maxProductStock: p?.totalInventory,
                    selectedVariants: [],
                    subscriptions: [],
                    oneTimePurchase: true,
                    isSubscribed: false,
                    variants: p?.variants?.map((variant: VariantsObj) => ({
                        image: { ...variant.image },
                        id: variant?.id,
                        displayName: variant.displayName,
                        title: variant?.title?.toLowerCase() == "default title" ? p?.title : variant?.title,
                        price: variant?.price,
                        quantity: 1,
                        selectedOptions: variant?.selectedOptions,
                        copyPrice: variant.price,
                        compareAtPrice: variant.compareAtPrice ? variant.compareAtPrice : variant.price,
                    })),
                    options: p?.options,
                });
            });
            setHasInteractedProduct(true);
            handleInputChange(selectedTab, { free_products: productsArr });
            setProductSearchQuery("");
        }
    };

    const removeProducts = (pId: string = "") => {
        const temp = [...free_gifts];
        let idx: number | undefined = -1;
        idx = temp.findIndex((p: any) => p.id == pId);

        if (idx >= 0) {
            temp.splice(idx, 1);
            setHasInteractedProduct(true);
            handleInputChange(selectedTab, { free_products: temp });
        }
    };

    const handleQuantity = (pId = "", val: number) => {
        const temp: ProductObj[] = [...free_gifts];
        let idx: number | undefined = -1;

        idx = temp.findIndex((p) => p.id == pId);

        if (idx >= 0) {
            temp[idx] = {
                ...temp[idx],
                quantity: val,
            };
        }
        setHasInteractedProduct(true);
        handleInputChange(selectedTab, { free_products: temp });
    };

    return (
        <div className={styles.gift_container}>
            <TextField
                label={"Search Product"}
                labelHidden
                placeholder="Search Products"
                autoComplete={"off"}
                value={productSearchQuery}
                onChange={(val) => {
                    setProductSearchQuery(val);
                }}
                prefix={<Icon source={SearchIcon} />}
                size="slim"
                connectedRight={
                    <div style={{ marginLeft: "8px" }}>
                        <Button onClick={() => handleProductSearch()} size="slim">
                            Browse
                        </Button>
                    </div>
                }
                error={offerError}
            />

            {free_gifts?.length > 0 && (
                <div className={styles.renderFreeGiftFormSide}>
                    {free_gifts?.map((p: any, index: number) => (
                        <div className={styles.container}>
                            <div className={styles.container_wrapper}>
                                <div className={styles.img_container}>
                                    <Thumbnail
                                        source={p?.images?.[0]?.originalSrc || CollectionIcon}
                                        alt={p?.title}
                                        size={"small"}
                                    />
                                </div>
                                <p style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                    <span style={{ fontSize: "14px" }}>{p?.title}</span>
                                    {p?.variants?.length > 1 && (
                                        <span
                                            style={{
                                                fontSize: "10px",
                                            }}
                                        >
                                            {p?.variants?.length} variants selected
                                        </span>
                                    )}
                                </p>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    gap: "10px",
                                    alignItems: "center",
                                    maxWidth: "130px",
                                    width: "130px",
                                }}
                            >
                                <TextField
                                    label={"Quantity"}
                                    labelHidden
                                    type={"number"}
                                    size="slim"
                                    min={1}
                                    placeholder={"Quantity"}
                                    autoComplete={"off"}
                                    value={p.quantity.toString()}
                                    suffix={"Qty"}
                                    onBlur={() => {
                                        if (Number(p.quantity) < 1) {
                                            const temp = [...free_gifts];
                                            temp[index].quantity = 1;
                                            setHasInteractedProduct(true);
                                            handleInputChange(selectedTab, { free_gifts: temp });
                                        }
                                    }}
                                    onChange={(val) => {
                                        handleQuantity(p.id, +val);
                                        // const temp = [
                                        //     ...free_gifts,
                                        // ];
                                        // temp[
                                        //     index
                                        // ].quantity =
                                        //     Number(val);

                                        // dispatchBundleConfig(
                                        //     {
                                        //         payload:
                                        //             temp,
                                        //         key: "free_gifts",
                                        //     },
                                        // );
                                        // free_gifts?.onChange(
                                        //     temp,
                                        // );
                                    }}
                                />

                                <div
                                    onClick={() => {
                                        removeProducts(p.id);
                                    }}
                                    className={styles.closeIcon}
                                >
                                    <CloseIcon />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default FreeGiftReward;
